export default "__VITE_ASSET__CG$nNLYe__"